import * as React from 'react';
import { Label, UIText2 } from '@cian/ui-kit';
import { IconHighDemand16 } from '@cian/ui-kit/icons';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';

export interface IBuilderStatusProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export function BuilderStatus(props: IBuilderStatusProps) {
  const { labelText, tooltipText, tooltipTitle } = props;

  return (
    <TooltipDesktop
      theme={'white'}
      title={
        <div className={styles['tooltip']}>
          <div className={styles['title']}>
            <ArticleParagraph1 fontWeight={'bold'}>{tooltipTitle}</ArticleParagraph1>
          </div>
          <UIText2>{tooltipText}</UIText2>
        </div>
      }
    >
      <div className={styles['label']}>
        <Label background="#3ac500" color="white_100" icon={<IconHighDemand16 color="white_100" />}>
          {labelText}
        </Label>
      </div>
    </TooltipDesktop>
  );
}
